"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usersStore = exports.LogCategory = void 0;
const endpoint_1 = require("api/endpoint");
const api_1 = require("client/api");
const material_ui_icons_1 = require("material-ui-icons");
const mobx_1 = require("mobx");
const react_1 = require("react");
const logger_1 = require("shared/logger");
const user_permission_1 = require("shared/user-permission");
const log = new logger_1.Logger("users/store");
/**
 * This had to be duplicated from "shared/action-log" due to some
 * strange exporting error. Make sure you make changes on both files.
 */
var LogCategory;
(function (LogCategory) {
    LogCategory["claim"] = "claim";
    LogCategory["distributor"] = "distributor";
    LogCategory["eob"] = "eob";
    LogCategory["general"] = "general";
    LogCategory["ledger"] = "ledger";
    LogCategory["order"] = "order";
    LogCategory["inventory"] = "inventory";
    LogCategory["inventorySite"] = "inventorySite";
    LogCategory["inventorySiteLot"] = "inventorySiteLot";
    LogCategory["purchaseOrder"] = "purchaseOrder";
    LogCategory["pad"] = "pad";
    LogCategory["patient"] = "patient";
    LogCategory["payment"] = "payment";
    LogCategory["pharmacy"] = "pharmacy";
    LogCategory["provider"] = "provider";
    LogCategory["queue"] = "queue";
    LogCategory["schedule"] = "schedule";
    LogCategory["user"] = "user";
})(LogCategory = exports.LogCategory || (exports.LogCategory = {}));
class UsersStore {
    constructor() {
        this.user = {
            loading: true,
            value: null
        };
        this.userProvider = {
            loading: true,
            value: null
        };
        this.permissions = {};
        this.originalPermissions = {}; // pharmacies | View disabled sites (sites list). // E-050 2024-04-30 21:55:15
        this.token = { value: endpoint_1.getCurrentToken() };
        this.submission = {};
        this.poReceivedNotification = {}; //C-036.1
        this.submitted = false;
        this.sessionKey = "";
        this.setToken = (token) => {
            localStorage.setItem("token", token);
            this.token = { value: token };
        };
        this.checkLoginValid = async () => {
            const response = await api_1.UserEndpoint.checkLoginValid.apiCall(null, { portalToken: localStorage.getItem("portalToken") });
            if (api_1.isError(response))
                return "oops";
            if (!response.valid) {
                this.setToken("");
                await this.loadUser();
            }
            return response.valid;
        };
        this.getSessionKey = async (userId) => {
            const response = await api_1.UserEndpoint.sessionKey.apiCall(null, { userId });
            if (api_1.isError(response)) {
                return "Error pulling session key";
            }
            else {
                this.sessionKey = response.sessionKey;
            }
        };
        this.loadUser = async () => {
            // Load the user
            const response = await api_1.UserEndpoint.current.apiCall();
            await this.loadUserPermissions();
            await this.loadUserOriginalPermissions(); // pharmacies | View disabled sites (sites list). // E-050 2024-04-30 21:55:15
            await this.loadUserProvider();
            log.debug("response", response);
            if (api_1.isError(response)) {
                this.user = {
                    error: "Unable to load user",
                    loading: false,
                    value: null
                };
            }
            else {
                // console.log('response.user: ', response.user);
                if (!this.sessionKey) {
                    await this.getSessionKey(response.user.id);
                }
                localStorage.setItem("userdata", `${response.user.autoLogOutTime}`); //E-048
                this.user = {
                    error: response.user ? "" : "Not logged in",
                    loading: false,
                    value: response.user
                };
            }
        };
        this.loadUserProvider = async () => {
            // Load the user
            const response = await api_1.UserEndpoint.loaduserprovider.apiCall();
            if (api_1.isError(response)) {
                this.userProvider = {
                    error: "Unable to load user provider",
                    loading: false,
                    value: null
                };
            }
            else {
                // console.log("response.user prov: ", response.userProv);
                this.userProvider = {
                    error: "",
                    loading: false,
                    value: response.userProv ? response.userProv : null
                };
            }
        };
        this.loadUserPermissions = async () => {
            const response = await api_1.UserEndpoint.readPermissions.apiCall();
            if (api_1.isError(response))
                return "oops";
            const permissions = response.permissions;
            const checkAccess = (access) => permissions.includes(access);
            Object.keys(user_permission_1.Access).forEach((key) => {
                this.permissions[key] = checkAccess(key);
            });
        };
        /**
       * loadPermissionForPOAlert return the ReceivedPOAlert details from users permission
       * @returns C-036.1
       */
        this.loadPermissionForPOAlert = async () => {
            const response = await api_1.UserEndpoint.readPOAlertAccess.apiCall();
            if (api_1.isError(response))
                return "oops";
            this.poReceivedNotification = response.permissions;
        };
        // pharmacies | View disabled sites (sites list). // E-050 2024-04-30 21:55:15
        this.loadUserOriginalPermissions = async () => {
            const response = await api_1.UserEndpoint.readOriginalPermissions.apiCall();
            if (api_1.isError(response))
                return "oops";
            const permissions = response.permissions;
            const checkAccess = (access) => permissions.includes(access);
            Object.keys(user_permission_1.Access).forEach((key) => {
                this.originalPermissions[key] = checkAccess(key);
            });
        };
        this.loadAllPermissions = async (query = { start: 0, count: null }) => {
            const response = await api_1.UserEndpoint.readAllPermissions.apiCall({
                query
            });
            console.log("response ", response);
            if (api_1.isError(response))
                return "oops";
            return response.permissions;
        };
        this.createLog = async (logData) => {
            const response = await api_1.UserEndpoint.createLog.apiCall(null, {
                logData
            });
            if (api_1.isError(response))
                return "Error logging data";
            return response;
        };
        this.updatePermissions = async (permissions) => {
            const response = await api_1.UserEndpoint.updatePermissions.apiCall(null, {
                permissions
            });
            if (api_1.isError(response))
                return "oops";
            return response;
        };
        //E-048
        this.updateAutoLogoutTime = async (AutoLogoutTimeArray) => {
            const response = await api_1.UserEndpoint.AutoLogOutEndpoint.apiCall(null, {
                AutoLogoutTimeArray
            });
            if (api_1.isError(response))
                return "oops";
            return response;
        };
        this.updateGroup = async (groupId) => {
            const response = await api_1.UserEndpoint.updateGroup.apiCall(null, {
                groupId
            });
            if (api_1.isError(response))
                return "Failed to set user group.";
            return response;
        };
        this.updateSite = async (siteId) => {
            const response = await api_1.UserEndpoint.updateSite.apiCall(null, {
                siteId
            });
            if (api_1.isError(response))
                return "Failed to set user site.";
            return response;
        };
        this.showLock = () => {
            console.log("Lockdown displayed.");
            return react_1.createElement("div", { style: { padding: "1rem" } }, react_1.createElement(material_ui_icons_1.Lock, {
                style: {
                    width: "3rem",
                    height: "3rem",
                    color: "gainsboro",
                    margin: "0 auto",
                    display: "block"
                }
            }, {}), react_1.createElement("p", { style: { textAlign: "center" } }, "You do not have permission to view this.")); //
        };
        this.deleteUpload = async (uploadId) => {
            const result = await api_1.UserEndpoint.removeFile.apiCall({
                params: { id: uploadId }
            });
            if (api_1.isError(result)) {
                // this.upload = {
                //   error: result.code,
                //   value: this.uploads.value,
                // };
                console.log("Error in deleting user asset.");
            }
            else {
                // await usersListStore.loadUsers();
                console.log("Successfully deleted uploaded user asset.");
            }
        };
        this.upload = async (files, userId, uploadType) => {
            this.submission = {
                loading: true,
                value: this.submission.value
            };
            const formData = new FormData();
            files.forEach(file => {
                formData.append("newFile", file); // Why is name gone?
            });
            formData.append("userId", userId);
            formData.append("uploadType", uploadType);
            const response = await api_1.UserEndpoint.uploadFile.apiCall(null, formData);
            if (api_1.isError(response)) {
                this.submission = { error: response.code, value: this.submission.value };
            }
            else {
                this.submission = { value: this.submission.value };
                this.submitted = true;
                // await usersListStore.loadUsers();
            }
        };
        mobx_1.autorun(async () => {
            if (!this.token.loading) {
                if (this.token.value) {
                    this.loadUser();
                }
                else {
                    this.user = {
                        error: "You are not logged in",
                        loading: false,
                        value: null
                    };
                }
            }
        });
    }
    get loading() {
        console.log(mobx_1.toJS(this.token.loading, this.user.loading));
        return this.token.loading || this.user.loading;
    }
}
__decorate([
    mobx_1.observable
], UsersStore.prototype, "user", void 0);
__decorate([
    mobx_1.observable
], UsersStore.prototype, "userProvider", void 0);
__decorate([
    mobx_1.observable
], UsersStore.prototype, "permissions", void 0);
__decorate([
    mobx_1.observable
], UsersStore.prototype, "token", void 0);
__decorate([
    mobx_1.observable
], UsersStore.prototype, "submission", void 0);
__decorate([
    mobx_1.observable
], UsersStore.prototype, "poReceivedNotification", void 0);
__decorate([
    mobx_1.observable
], UsersStore.prototype, "submitted", void 0);
__decorate([
    mobx_1.observable
], UsersStore.prototype, "sessionKey", void 0);
__decorate([
    mobx_1.computed
], UsersStore.prototype, "loading", null);
__decorate([
    mobx_1.action
], UsersStore.prototype, "setToken", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "checkLoginValid", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "getSessionKey", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "loadUser", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "loadUserProvider", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "loadUserPermissions", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "loadPermissionForPOAlert", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "loadUserOriginalPermissions", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "loadAllPermissions", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "createLog", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "updatePermissions", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "updateAutoLogoutTime", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "updateGroup", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "updateSite", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "showLock", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "deleteUpload", void 0);
__decorate([
    mobx_1.action
], UsersStore.prototype, "upload", void 0);
exports.usersStore = new UsersStore();



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/users/store.ts
// module id = 25
// module chunks = 0 1 2